
export const OPENAI_API_KEY = 'sk-kuKcBsZjaM2-Q__nT9I4LfERztUvydGPEen6fuEZQAT3BlbkFJP3K_oJjFF6xevbNJTnPzyXBwRbaVKTkf6VgGyEbZ8A';

export const OPENAI_ORG_ID = 'org-t2NUDrOfFcGx4eKktVSJ4bG3';
